"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = InputFieldLabel;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _uiIcons = require("@blueprism/ui-icons");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var StyledLabel = _styledComponents["default"].label.withConfig({
  displayName: "InputFieldLabel__StyledLabel",
  componentId: "sc-10wpdw9-0"
})(["display:flex;flex-flow:column nowrap;width:100%;color:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.color.text;
});

var LabelContainer = _styledComponents["default"].div.withConfig({
  displayName: "InputFieldLabel__LabelContainer",
  componentId: "sc-10wpdw9-1"
})(function (props) {
  return (0, _styledComponents.css)(["display:inline-flex;align-items:center;border-radius:0.125rem;", ""], props.error && (0, _styledComponents.css)(["background-color:", ";color:", ";"], props.theme.color.warning, props.theme.color.paper));
});

var IconContainer = _styledComponents["default"].div.withConfig({
  displayName: "InputFieldLabel__IconContainer",
  componentId: "sc-10wpdw9-2"
})(["display:inline-flex;justify-content:center;align-items:center;width:2rem;height:100%;margin:auto;"]);

var LabelText = _styledComponents["default"].div.withConfig({
  displayName: "InputFieldLabel__LabelText",
  componentId: "sc-10wpdw9-3"
})(["flex-grow:1;line-height:1.6rem;font-weight:", ";"], function (props) {
  return props.theme.font.weight.bold;
});

var ValidationText = _styledComponents["default"].div.withConfig({
  displayName: "InputFieldLabel__ValidationText",
  componentId: "sc-10wpdw9-4"
})(["color:", ";margin:0.8rem 0 0.8rem 2rem;font-size:0.8rem;"], function (props) {
  return props.theme.color.text;
});
/**
 *
 * #### Inputfield Label

The `InputFieldLabel` is designed to be used alongside `InputField` to build compound components such as `FormField`. `InputFieldLabel` renders the HTML element of `<label>` to the DOM. An optional `validationLabel` can also be rendered, which can be used to provide further details or an error message.

 */


function InputFieldLabel(_ref2) {
  var htmlFor = _ref2.htmlFor,
      label = _ref2.label,
      _ref2$error = _ref2.error,
      error = _ref2$error === void 0 ? false : _ref2$error,
      _ref2$validationLabel = _ref2.validationLabel,
      validationLabel = _ref2$validationLabel === void 0 ? '' : _ref2$validationLabel,
      rest = _objectWithoutProperties(_ref2, ["htmlFor", "label", "error", "validationLabel"]);

  var theme = _react["default"].useContext(_styledComponents.ThemeContext);

  return /*#__PURE__*/_react["default"].createElement(StyledLabel, _extends({
    htmlFor: htmlFor
  }, rest), /*#__PURE__*/_react["default"].createElement(LabelContainer, {
    error: error
  }, /*#__PURE__*/_react["default"].createElement(IconContainer, null, error && /*#__PURE__*/_react["default"].createElement(_uiIcons.Alert, {
    size: 16,
    color: theme.color.paper
  })), /*#__PURE__*/_react["default"].createElement(LabelText, null, label)), /*#__PURE__*/_react["default"].createElement(ValidationText, null, validationLabel));
}